<template>
	<div>
		<div class="d-flex align-items-center">
			<div class="mcqtophead">Match</div>
			<div class="mcqtophead">
				Difficulty Level - {{ data.difficultyLevel }}
			</div>
			<div class="mcqtophead">{{ data.marks }} Mark</div>
		</div>

		<div class="questiontext">
			<div class="d-flex">
				<div>Q{{ showindex }}.</div>
				<div class="ml-1 topicDescBreak" v-html-safe="data.question"></div>
			</div>
			<div class="my-3" v-if="data.questionMedia != null">
				<div v-if="isImage(data.questionMediaType)">
					<img class="qb-image-preview" :src="data.questionMedia" alt="" />
				</div>
				<div v-if="isAudio(data.questionMediaType)" class="d-flex">
					<Media
						:kind="'audio'"
						:isMuted="false"
						:src="data.questionMedia"
						:autoplay="false"
						:controls="true"
						:loop="true"
						width="70%"
						class="qb-audio-preview"
					></Media>
				</div>
				<div v-if="isVideo(data.questionMediaType)" class="d-flex">
					<Media
						:kind="'video'"
						:isMuted="false"
						:src="data.questionMedia"
						:autoplay="false"
						:controls="true"
						:loop="true"
						width="70%"
						height="30%"
						class="qb-vedio-preview"
					></Media>
				</div>
			</div>
			<div>
				<b-form-radio-group id="radio-group-2" name="radio-sub-component">
					<b-row
						class="mt-3"
						v-for="(option, index) of data.answerKey"
						:key="index"
					>
						<b-col cols="5">
							<div class="topDiv">
								<label class="fieldsetStyle"
									>Match A&nbsp;<span class="asterik">*</span></label
								>

								<b-form-textarea
									class="inputField overflow-auto"
									disabled
									type="text"
									v-model="option.sideA"
									rows="1"
									:max-rows="6"
								></b-form-textarea>
							</div>
							<!-- give filter "topicNameFilter" -->
						</b-col>
						<b-col
							cols="2"
							class="d-flex align-items-center justify-content-center"
							><img src="../../assets/interchange.svg" alt=""
						/></b-col>
						<b-col cols="5">
							<div class="topDiv">
								<label class="fieldsetStyle"
									>Match B&nbsp;<span class="asterik">*</span></label
								>
								<b-form-textarea
									class="inputField overflow-auto"
									id="input-1"
									disabled
									type="text"
									rows="1"
									:max-rows="6"
									v-model="option.sideB"
								></b-form-textarea>
							</div>
						</b-col>
					</b-row>
				</b-form-radio-group>
			</div>
		</div>
	</div>
</template>

<script>
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";
export default {
	name: "mafo",
	props: {
		data: Object,
		showindex: Number,
	},
	methods: {
		isImage,
		isVideo,
		isAudio,
	},
};
</script>

<style scoped>
.custom-radio.b-custom-control-sm {
	width: 100px !important;
}
</style>
